(function () {
    'use strict';

    angular
        .module('app')
        .directive('availableCampaignCode', availableCampaignCodeDirective);

    availableCampaignCodeDirective.$inject = ['API', '$q',];

    function availableCampaignCodeDirective(API, $q) {
        var directive = {
            require: 'ngModel',
            restrict: 'A',
            scope: {
                existing: '@'
            },
            link: link,
        };

        return directive;

        function link(scope, element, attrs, ngModel) {
            ngModel.$asyncValidators.uniqueCampaignCode = function (value) {
                if (ngModel.$isEmpty(value) || !value) {
                    return $q.when();
                }

                var defer = $q.defer();

                API.CampaignCode.search({ code: value }).$promise.then(function (response) {
                    if (!response.items.length || response.items[0].fk_campaign_id === null) {
                        defer.resolve();
                    } else {
                        defer.reject(response);
                    }
                });

                return defer.promise;
            };
        }
    }
})();